import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik } from "formik";
import { BootstrapError, BootstrapField } from "../../helpers/Field";
import * as yup from 'yup';
import { toast } from 'react-toastify';
import moment from 'moment';

let schema = yup.object().shape({
    Login: yup.string().required("User Id is Required"),
    FirstName: yup.string().required("First Name Required"),
    LastName: yup.string().required("Last Name Required"),
    Company: yup.string().required("Company Required"),
    Email: yup.string().email().required("Email Required"),
    password: yup.string(),
    Status: yup.string().required("Status Required"),
    //userProfileId: yup.number().required("Profile Type Required"),
    PrimaryAccountTypeId: yup.number().required("Primary Account Type Required"),
    UserRole: yup.string().required("User Role Required"),
});

class ManageUserForm extends Component {

    constructor(props) {
        super(props);
        this.onSubmit = this.onSubmit.bind(this);
    }


    onSubmit(values, bag) {
        bag.setSubmitting(true);
        this.props.save(values).then((user) => {
            // this.setState({user: user});
            bag.setSubmitting(false);
        }).catch(error => {
            if (error.response.data && error.response.data.Message) {
                toast.warn(error.response.data.Message, { position: toast.POSITION.TOP_RIGHT });
                bag.setSubmitting(false);
            }
        });
    }

    render() {
        const createdDate = this.props.user && this.props.user.CreatedDate ? moment(this.props.user.CreatedDate).format('MMM DD YYYY') : '';
        const lastLoginDate = this.props.user && this.props.user.LastLoginDate ? moment(this.props.user.LastLoginDate).format('MMM DD, YYYY') : '';
        const lastPasswordChange = this.props.user && this.props.user.LastPasswordChange ? moment(this.props.user.LastPasswordChange).format('MM DD,') : '';
        if (this.props.primaryAccountTypes.length === 1) {
            this.props.user.PrimaryAccountTypeId = this.props.primaryAccountTypes[0].PrimaryAccountTypeId;
        }
        return (
            <Formik
                initialValues={this.props.user}
                enableReinitialize={true}
                validationSchema={schema}
                onSubmit={this.onSubmit}
                render={(props) =>
                    <form autoComplete={"new-user-form"}>
                        <div className="row">
                            <div className="col-12">
                                <div className={"row no-gutters mb-2"}>
                                    <h3 className={"col-6"}>User Info</h3>
                                    <div className={"col-6 text-right"}>
                                        <button className="btn btn-primary" type={"submit"} onClick={props.handleSubmit}>Save User</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        < div className="row">
                            <div className="col-12 col-md-4">
                                <div className="form-group row no-gutters">
                                    <label className={"col-4 col-form-label wa-label"}>User ID</label>
                                    <div className="col-8">
                                        <BootstrapField type="text" name="Login" placeholder={"User Id"} />
                                        <BootstrapError name="login" />
                                    </div>
                                </div>
                                <div className="form-group row no-gutters">
                                    <label className={"col-4 col-form-label wa-label"}>First Name</label>
                                    <div className="col-8">
                                        <BootstrapField type="text" name="FirstName" placeholder={"First Name"} />
                                        <BootstrapError name="FirstName" />
                                    </div>
                                </div>
                                <div className="form-group row no-gutters">
                                    <label className={"col-4 col-form-label wa-label"}>Last Name</label>
                                    <div className="col-8">
                                        <BootstrapField type="text" name="LastName" placeholder={"Last Name"} />
                                        <BootstrapError name="LastName" />
                                    </div>
                                </div>
                                <div className="form-group row no-gutters">
                                    <label className={"col-4 col-form-label wa-label"}>Company</label>
                                    <div className="col-8">
                                        <BootstrapField type="text" name="Company" placeholder={"Company"} />
                                        <BootstrapError name="company" />
                                    </div>
                                </div>
                                <div className="form-group row no-gutters">
                                    <label className={"col-4 col-form-label wa-label"}>Email</label>
                                    <div className="col-8">
                                        <BootstrapField type="text" name="Email" placeholder={"Email"} />
                                        <BootstrapError name="email" />
                                    </div>
                                </div>
                                <div className="form-group row no-gutters">
                                    <label className={"col-4 col-form-label wa-label"}>Password</label>
                                    <div className="col-8">
                                        <BootstrapField type="password" name="password" placeholder={"Password"} />
                                        <BootstrapError name="password" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-md-4">
                                <div className="form-group row no-gutters">
                                    <label className={"col-4 col-form-label wa-label"}>Status</label>
                                    <div className="col-8">
                                        <BootstrapField component="select" name="Status" placeholder={"Status"}>
                                            <option value="">Status</option>}
                                            <option value="active">Active</option>
                                            <option value="deactive">Deactive</option>
                                            <option value="waiting-confirmation">Waiting Confirmation</option>
                                            <option value="locked">Locked</option>
                                        </BootstrapField>
                                        <BootstrapError name="Status" />
                                    </div>
                                </div>
                                <div className="form-group row no-gutters">
                                    <label className={"col-4 col-form-label wa-label"}>Primary Account Type</label>
                                    <div className="col-8">
                                        <BootstrapField component="select" name="PrimaryAccountTypeId" placeholder={"Primary Acct Type"}>
                                            {this.props.primaryAccountTypes && this.props.primaryAccountTypes.length > 0 && <option value="">Primary Acct Type</option>}
                                            {/* <option value="SoldTo">Sold To</option>
                      <option value="Payer">Payer</option> 
                      <option value="PayerAll">Payer - All</option>*/}
                                            {this.props.primaryAccountTypes.map(accountType => {
                                                return (
                                                    <option value={accountType.PrimaryAccountTypeId} key={accountType.PrimaryAccountTypeId}>
                                                        {accountType.PrimaryAccountTypeValue}
                                                    </option>
                                                )
                                            })}
                                        </BootstrapField>
                                        <BootstrapError name="PrimaryAccountTypeId" />
                                    </div>
                                </div>
                                <div className="form-group row no-gutters">
                                    <label className={"col-4 col-form-label wa-label"}>User Role</label>
                                    <div className="col-8">
                                        <BootstrapField component="select" name="UserRole" placeholder={"User Role"}
                                            disabled={this.props.currentUser && (this.props.currentUser.UserRole).toLowerCase() !== "admin"}>
                                            <option value="">User Role</option>
                                            <option value="admin">Admin</option>
                                            <option value="manager">Manager</option>
                                            <option value="internal">Internal</option>
                                            <option value="user">User</option>
                                        </BootstrapField>
                                        <BootstrapError name="UserRole" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-md-4">
                                <div className="row no-gutters">
                                    <div className="col-12">
                                        <div className="row no-gutters">
                                            <div className="col-6 wa-label">Created</div>
                                            <div className="col-6">
                                                <span>{createdDate}</span>
                                            </div>
                                        </div>
                                        <div className="row no-gutters">
                                            <div className="col-6 wa-label">Last login</div>
                                            <div className="col-6"><span>{lastLoginDate}</span></div>
                                        </div>
                                        <div className="row no-gutters">
                                            <div className="col-6 wa-label">Login Count</div>
                                            <div className="col-6"><span>{this.props.user.NumLogins}</span></div>
                                        </div>
                                        <div className="row no-gutters">
                                            <div className="col-6 wa-label">Last Password Change</div>
                                            <div className="col-6">{lastPasswordChange}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                } />
        );
    }
}

ManageUserForm.propTypes = {
    onSave: PropTypes.func,
    save: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
};

export default ManageUserForm;
